import { render, staticRenderFns } from "./Mensagens.vue?vue&type=template&id=3f6fea70&"
import script from "./Mensagens.vue?vue&type=script&lang=js&"
export * from "./Mensagens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports